import React, { useState } from 'react';
import './Allfaqs.css';

const data = [
    {
        question: "Why choose the Weavebliss digital guestbook?",
        answer: "Weavebliss turns fleeting wedding moments into something lasting. Instead of a traditional guestbook that’s read once and stored away, your guests’ doodles come together to form a meaningful piece of wall art, while their messages and photos live on in a private digital guestbook. It’s easy for guests to use, beautifully designed, and gives you both a physical keepsake and a digital memory you can revisit anytime."
    },
    {
        question: "How do I use it?",
        answer: "Create an account and set up your digital guestbook before the event. Generate your unique guestbook link and QR code, then print and place the QR codes around the venue. Guests can contribute throughout the event. Afterward, all doodles, messages, and photos are curated into your guestbook and made available for download."
    },
    {
        question: "Is it easy for guests to use?",
        answer: "Yes. Guests simply scan a QR code—no app download or account registration is required. The interface is designed to be simple and intuitive, making it easy for guests of all ages to participate."
    },
    {
        question: "Do I have to use only the Weavebliss digital guestbook?",
        answer: "Not at all! You can use a physical guestbook alongside the Weavebliss digital guestbook. Place the physical guestbook at the reception and display the digital guestbook QR code on each table. Guests can doodle, leave messages, or upload photos digitally at their own pace during the event."
    },
    {
        question: "What will I receive after the event?",
        answer: "You will receive a high-resolution wall-art image formed entirely from your guests’ doodles, along with access to the complete digital guestbook containing all messages and photos. Everything can be downloaded and kept as a lasting keepsake."
    },
    {
        question: "Who can see my guestbook?",
        answer: "Your guestbook is private. Only people with your unique link or QR code can access it. All submitted content remains confidential and is never shared with third parties."
    },
    {
        question: "Can Weavebliss be used in any country?",
        answer: "Yes. Weavebliss is web-based and can be used anywhere in the world."
    },
    {
        question: "Is it free?",
        answer: "We offer two tiers: a free Lite tier and a Premium tier. The Lite tier lets you enjoy the core features of our digital guestbook and is suitable for small weddings of up to 30 guests. The Premium tier supports up to 200 guests and includes additional flexibility. Full details are available in our pricing section."
    },
    {
        question: "Can I upgrade later after trying the Lite tier?",
        answer: "Yes. You can start with the Lite tier to explore the basic features. When you’re ready, you can upgrade to the Premium tier to unlock higher guest limits and additional features."
    },
    {
        question: "How long will my digital guestbook be available?",
        answer: "Your digital guestbook stays online for one year by default. After that, you can extend access at a minimal cost. We’ll remind you before the guestbook expires, and you’ll always be able to download and keep a copy of your memories."
    },
    {
        question: "How can I contact support?",
        answer: "If you need help at any stage, you can reach our support team through the contact form or email listed on our website."
    }
];

function Allfaqs({ openall }) {
    const [openIndex, setOpenIndex] = useState(0);

    const toggle = (index) => { setOpenIndex(openIndex === index ? null : index); }

    return (
        <div className='Gbfinaldisplay_root' style={{ display: 'flex', flexDirection: 'column' }}>
            <div className='Allfaq_title'>FAQ</div>

            {openall
                ? data.map((item, index) => (
                    <div className='Gbdrawings_subtitle' style={{ marginBottom: index === data.length - 1 ? 150 : 10 }} key={index}>
                        <h3
                            className={`faq-question open`}
                            onClick={() => toggle(index)}
                        >
                            {item.question}
                        </h3>

                        <div
                            className={`faq-answer open`}
                        >
                            <p>{item.answer}</p>
                        </div>
                    </div>
                ))
                : data.map((item, index) => (
                    <div className='Gbdrawings_subtitle' style={{ marginBottom: index === data.length - 1 ? 150 : 10 }} key={index}>
                        <h3
                            className={`faq-question ${openIndex === index ? 'open' : ''}`}
                            onClick={() => toggle(index)}
                        >
                            {item.question}
                        </h3>

                        <div
                            className={`faq-answer ${openIndex === index ? 'open' : ''}`}
                        >
                            <p>{item.answer}</p>
                        </div>
                    </div>
                ))
            }

        </div>
    );
}

export default Allfaqs;
